import {
    SUCCESS_GET_ADDRESS_BOOK,
    FAILED_GET_ADDRESS_BOOK,
    SUCCESS_DELETE_ADDRESS_BOOK_ENTRY,
    FAILED_DELETE_ADDRESS_BOOK_ENTRY,
    SUCCESS_UPDATE_ADDRESS_BOOK_ENTRY,
    FAILED_UPDATE_ADDRESS_BOOK_ENTRY,
} from '../constants/addressBookConstants';

const defaultState = {
    addressBookEntries: [],
    addressBookTotal: 0,
    addressBookPage: 0,
    addressBookPageSize: 25,
    errorMessage: '',
};

export const AddressBookReducer = (state = defaultState, { type, payload, errorMessage }) => {
    switch (type) {
        case SUCCESS_GET_ADDRESS_BOOK:
            return {
                ...state,
                addressBookEntries: payload.results,
                addressBookTotal: payload.total,
                addressBookPage: payload.page,
                addressBookPageSize: payload.pageSize,
                errorMessage: null,
            };
        case SUCCESS_DELETE_ADDRESS_BOOK_ENTRY:
            return {
                ...state,
                addressBookEntries: state.addressBookEntries.filter((entry) => entry.id !== payload),
                addressBookTotal: Math.max(0, state.addressBookTotal - 1),
                errorMessage: null,
            };
        case SUCCESS_UPDATE_ADDRESS_BOOK_ENTRY: {
            const { oldId, entry } = payload;
            if (oldId === entry.id) {
                return {
                    ...state,
                    addressBookEntries: state.addressBookEntries.map(
                        (row) => (row.id === oldId ? entry : row)
                    ),
                    errorMessage: null,
                };
            }
            return {
                ...state,
                addressBookEntries: state.addressBookEntries
                    .filter((row) => row.id !== oldId)
                    .concat([entry]),
                errorMessage: null,
            };
        }
        case FAILED_GET_ADDRESS_BOOK:
        case FAILED_DELETE_ADDRESS_BOOK_ENTRY:
        case FAILED_UPDATE_ADDRESS_BOOK_ENTRY:
            return {
                ...state,
                errorMessage: errorMessage,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/addressBookReducer.js